import { Component, Input, OnInit } from '@angular/core';
import { ZkEButtonColor } from '@zenklub/ng-ui';
import { GlobalService } from 'app/services/global.service';
import { ZkuService } from 'app/services/zku.service';
import { UnleashService } from 'shared/unleash/unleash.service';

import { environment } from '../../../environments/environment';

@Component({
	selector: 'financial-report-looker',
	templateUrl: './financial-report-looker.component.html',
	styleUrls: ['./financial-report-looker.component.scss'],
})
export class FinancialReportLookerComponent implements OnInit {
	@Input()
	showClientSearch = true;

	@Input()
	clientId: string;

	isMobile = false;

	public isSupersetEnabled = false;

	zkEButtonColor = ZkEButtonColor;

	dashboard: string;
	dashboards = [
		{
			label: 'PAGES.FINANCIALS.ALL_SESSIONS',
			dashboard: '216',
			width: 230,
		},
		{
			label: 'PAGES.FINANCIALS.NO_CORPORATIVE_SESSIONS',
			dashboard: '223',
			width: 230,
		},
	];

	dashboardsSuperset = [
		{
			label: 'PAGES.FINANCIALS.ALL_SESSIONS',
			dashboard: environment.superset.dashboards.financialReport.id,
			width: 230,
		},
		{
			label: 'PAGES.FINANCIALS.NO_CORPORATIVE_SESSIONS',
			dashboard: environment.superset.dashboards.financialReportNoCop.id,
			width: 230,
		},
	];

	dashboardZen = [
		{
			label: 'PAGES.FINANCIALS.NO_CORPORATIVE_SESSIONS',
			dashboard: '227',
			width: 230,
		},
	];

	isProfessionalZen: boolean;
	isProfessionalZenPartner: boolean;

	constructor(
		public global: GlobalService,
		private zkuService: ZkuService,
		private unleashService: UnleashService
	) {}

	public async ngOnInit() {
		const userService = this.zkuService.getZku();
		this.isProfessionalZen = userService?.tags?.some(
			(tag) => tag['id'] === 'professional_zen'
		);

		this.isProfessionalZenPartner = userService?.tags?.some(
			(tag) => tag['id'] === 'professional_zen_partner'
		);

		this.isSupersetEnabled = this.unleashService.isEnabled(
			'superset-financial-report'
		);

		if (!this.isSupersetEnabled) {
			this.dashboard = this.isProfessionalZen
				? this.dashboardZen[0].dashboard
				: this.dashboards[0].dashboard;

			this.dashboard = this.isProfessionalZenPartner
				? this.dashboardZen[0].dashboard
				: this.dashboards[0].dashboard;
		} else {
			this.dashboard = this.dashboardsSuperset[0].dashboard;
		}

		this.isMobile = this.global.isMobileDevice();
	}

	public onResize(): void {
		this.isMobile = this.global.isMobileDevice();
	}

	public changeDashboard(dashboard: string) {
		this.dashboard = dashboard;
	}
}
